import { render, staticRenderFns } from "./StatusBubble.vue?vue&type=template&id=c8bfea12&scoped=true"
import script from "./StatusBubble.vue?vue&type=script&lang=js"
export * from "./StatusBubble.vue?vue&type=script&lang=js"
import style0 from "./StatusBubble.vue?vue&type=style&index=0&id=c8bfea12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bfea12",
  null
  
)

export default component.exports